"use client";

import React, { useState } from "react";

import Image from "next/image";

import { ResetPasswordForm } from "@/components";
import { SendVerificationCodeForm } from "../../../components";

export default function Page () {

  const [userEmail, setUserEmail] = useState('');
  const [isCodeSent, setIsCodeSent] = useState(false);
  
  return (
    <div className="flex h-screen">
      <div className="w-[100%] md:w-[45%] overflow-y-auto">

        <div className="flex flex-col h-screen justify-between align-center">
          <div></div>

          <div className="w-full max-w-[350px] flex flex-col justify-center items-center self-center">
            <div className="w-full mb-4">
              {isCodeSent ? 
                (<>
                  <h3 className="scroll-m-20 text-3xl font-semibold tracking-tight mb-1">Restablecer contraseña</h3>
                  <p className="text-sm">Hemos enviado un código de verificación a tu correo electrónico. Por favor, ingrésalo junto con tu nueva contraseña para completar el proceso de restablecimiento.</p>
                </>) : (<>
                  <h3 className="scroll-m-20 text-3xl font-semibold tracking-tight mb-1">Olvidó su contraseña</h3>
                  <p className="text-sm">Ingrese su correo elctrónico</p>
                </>)}
            </div>

            {!isCodeSent
              ? <SendVerificationCodeForm onSent={setIsCodeSent} setUserEmail={setUserEmail} />
              : <ResetPasswordForm userEmail={userEmail} onBack={() => setIsCodeSent(false)} />}
          </div>

          <div className="p-4">
            <div className="flex flex-wrap items-center justify-center md:justify-between">
              <p>© VyAInversiones 2024</p>
            </div>
          </div>
        </div>
        
      </div>
      
      <div className="hidden md:flex md:flex-1 bg-slate-100 items-center justify-center relative">
        <Image src="/images/auth-banner-1.png" alt="auth-banner-1" fill />
      </div>
    </div>
  );
};
